import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/home";
import PreAdmission from "./pages/preadmission";
import PostAdmission from "./pages/postadmission";
import PostAdmissionPages from "./pages/postAdmissionPages";
import ScrollToTop from "./utils/ScrollToTop";
import Footer from "./components/footer";

function App() {
  return (
    <div className="App">
      <div className="pages_container">
        <BrowserRouter>
          <ScrollToTop>
            <Routes>
              <Route exact path="/" element={<Home />}></Route>
              <Route exact path="/preAdmission" element={<PreAdmission />}></Route>
              <Route te exact path="/postAdmission" element={<PostAdmission />}></Route>
              <Route exact path="/postAdmission/:section" element={<PostAdmissionPages />}></Route>
            </Routes>
          </ScrollToTop>
        </BrowserRouter>
      </div>
      <Footer />
    </div>
  );
}

export default App;
